import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput, FormToggle } from "components/BaseForm";
import { Spinner } from "@/components/ui/spinner";
import PointOfContactService from "services/PointOfContact";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  enabled: z.boolean(),
});

function PointOfContactForm({ model, onSuccess }) {
  const { data: pointOfContact } = useQuery({
    queryKey: ["point-of-contact", model?.id],
    queryFn: () => PointOfContactService.get(model.id),
    enabled: !!model?.id,
  });

  const initialValues = useMemo(() => {
    if (!model?.id) {
      return { name: "", enabled: true };
    }
    return (
      pointOfContact && {
        name: pointOfContact.name,
        enabled: pointOfContact.enabled,
      }
    );
  }, [model?.id, pointOfContact]);

  const handleSubmit = async values => {
    const data = { name: values.name, enabled: values.enabled };
    if (model?.id) {
      await PointOfContactService.update(model.id, data);
    } else {
      await PointOfContactService.create(data);
    }
    toast.success("Point of Contact saved");
  };

  if (!initialValues) {
    return <Spinner />;
  }

  return (
    <BaseForm
      schema={schema}
      defaultValues={initialValues}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required />
      <FormToggle name="enabled" label="Enabled" />
    </BaseForm>
  );
}

export default PointOfContactForm;
